import { lazy } from 'react';
import { isChunkLoadError, reloadOnceForChunkError } from './chunkLoadError';

/**
 * Wraps a dynamic `import()` so a failed chunk fetch reloads the page (once
 * per cooldown) instead of throwing into the error boundary. While the reload
 * is in flight the returned promise stays pending, so React.lazy keeps
 * showing the Suspense fallback rather than flashing an error.
 */
export const importWithRetry = (importer) => () => importer().catch((error) => {
  if (isChunkLoadError(error) && reloadOnceForChunkError()) {
    return new Promise(() => {});
  }
  throw error;
});

const lazyWithRetry = (importer) => lazy(importWithRetry(importer));

export default lazyWithRetry;
